export const FORM_IDENTIFIER = 'app/BudgetFormPage';

export const INIT = 'app/BudgetFormPage/INIT';
export const INIT_SUCCESS = 'app/BudgetFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/BudgetFormPage/INIT_FAILED';

export const SAVE = 'app/BudgetFormPage/SAVE';
export const SAVE_SUCCESS = 'app/BudgetFormPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/BudgetFormPage/SAVE_FAILED';

export const REMOVE = 'app/BudgetFormPage/REMOVE';
export const REMOVE_SUCCESS = 'app/BudgetFormPage/REMOVE_SUCCESS';
export const REMOVE_FAILED = 'app/BudgetFormPage/REMOVE_FAILED';
